const messages = {
  title: "Prijslijsten",
  description:
    "Welkom bij het informatiegedeelte over Bridgestone- en Firestone-producten. Hier vindt u actuele brochures, prijslijsten en Pricat-bestanden.",
  main: {
    title: "Prijslijsten",
    description:
      "Download hier de actuele prijslijsten voor onze Bridgestone- en Firestone-banden:<br /><ul><li>Auto's, 4x4's en bestelwagens</li></ul>",
  },
  pkw: {
    title: "Personenwagens, 4x4/SUV en bestelwagens",
    description:
      "Download hier de actuele prijslijsten voor onze Bridgestone- en Firestone-banden:<br /><ul><li>Auto's, 4x4's en bestelwagens</li></ul>",
  },
  productInfo: {
    categories: {
      priceList: "Prijslijsten",
    },
  },
  priceDescription: "Download hier onze prijslijsten",
};
export default {
  messages,
};
